import { render, staticRenderFns } from "./OnboardForm.vue?vue&type=template&id=453dcb2b&"
import script from "./OnboardForm.vue?vue&type=script&lang=js&"
export * from "./OnboardForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardForm.vue?vue&type=style&index=0&id=453dcb2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports